import { gql } from "../../../__generated__/gql";

export const SEND_NOTIFICATION =
  gql(`mutation notification($title: String!, $message:String!, $exportNumber: String, $sendAfter: String, $postId: String) {
    sendNotification(title: $title, message:$message, exportNumber:$exportNumber, sendAfter: $sendAfter, postId: $postId)
  }`);
